import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FavouriteButton } from "./FavouriteButton";

export const FactCard = ({ fact, index = 0 }) => (
  <Link
    to={`/curio/${fact.slug}`}
    data-testid={`fact-card-${fact.slug}`}
    className="group block bg-white border border-[#D8CEB9] rounded-sm overflow-hidden hover:border-[#9E4535] transition-all duration-300 hover:-translate-y-1 cv-fade-up"
    style={{ animationDelay: `${index * 60}ms` }}
  >
    <div className="relative aspect-[3/2] overflow-hidden bg-[#F3EDE0]">
      <FavouriteButton slug={fact.slug} />
      {fact.video_url ? (
        <video
          src={fact.video_url}
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <img
          src={fact.image_url || undefined}
          alt={`${fact.title} — AI illustration`}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#1A1615]/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
    </div>
    <div className="p-5">
      <p className="font-mono-cv text-[10px] text-[#B8AC9C] mb-3">Image generated by CurioVault AI — copyright free</p>
      <h3 className="font-serif-display text-lg sm:text-xl font-semibold text-[#1A1615] leading-snug group-hover:text-[#9E4535] transition-colors">
        {fact.title}
      </h3>
      <p className="font-body text-sm text-[#4A4036] mt-2 leading-relaxed line-clamp-3">
        {fact.hook}
      </p>
      <span className="inline-flex items-center gap-1 mt-4 font-ui text-xs font-semibold uppercase tracking-wider text-[#9E4535]">
        Read curio <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </span>
    </div>
  </Link>
);
